<template>
  <base-edit></base-edit>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'costAdjustOrderEdit',
    components: {
      baseEdit,
    },
  };
</script>
